import "./IconButton.css";

const IconButton = ({ children, disabled, onClick, className, style, title }) => {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={`icon-button ${className ?? ""}`}
      style={style}
      title={title}
    >
      {children}
    </button>
  );
};

export default IconButton;
